import React, {Component} from 'react'
import {observer} from 'mobx-react'

import Field from '../../struct/Field'
import Hint from '../../struct/Hint'
import SettingsGroup from '../../struct/SettingsGroup'
import Select from '../../control/DependentSelect'
import ExtraUrlParamsSettings from './ExtraUrlParamsSettings'

const protocol_options = [{
    label: 'https',
    value: '1',
}, {
    label: 'http',
    value: '0',
},]

@observer export default class ProfileRouteSettings extends Component {
    render() {
        const {title} = this.props
        /** @type {ProfileSettingsContext} */
        const context = this.props.context
        const profile = context.profile

        return (
            <SettingsGroup title={title}>
                <Field label="Витрина" required>
                    <Select
                        options={context.storefront_options}
                        value={profile.route_storefront}
                        onChange={e => context.changeProfileStorefront(e.target.value)}
                        state={context.form_state}
                    />
                    <Hint>Витрину необходимо указать для правильного формирования адресов страниц товаров в YML-файле и
                        отбора товаров для экспорта.</Hint>
                </Field>

                <Field label="Протокол">
                    <Select
                        options={protocol_options}
                        value={profile.route_is_https ? '1' : '0'}
                        onChange={e => profile.route_is_https = e.target.value === '1'}
                        state={context.form_state}
                    />
                </Field>

                <ExtraUrlParamsSettings context={context}/>
            </SettingsGroup>
        )
    }
}